<script setup lang="ts">
import { computed } from 'vue'
import { CButton } from '@/shared/ui'

interface CourseCardProps {
  title: string
  description: string
  bgColor?: string
  image?: string
  priceText: string
  buttonText?: string
  bgImage?: string
  textWhite?: boolean
}

interface CourseCardEmits {
  learnMore: []
}

const props = defineProps<CourseCardProps>()
defineEmits<CourseCardEmits>()

const computedBgImage = computed(() => {
  if (!props.bgImage) 
    return 'none'

  if (props.bgImage.startsWith('@/')) {
    const relativePath = props.bgImage.replace('@/', '')
    return `url(/src/${relativePath})`
  }

  if (props.bgImage.startsWith('http') || props.bgImage.startsWith('/')) {
    return `url(${props.bgImage})`
  }

  return `url(/${props.bgImage})`
})
</script>

<template>
  <div
    class="bg-white rounded-xl p-4 flex gap-2.5 min-h-[232px] bg-image shadow-[0px_2px_8px_0px_#365AC50D]"
    :style="{
      backgroundColor: bgColor || '#F8FAFC',
      backgroundImage: computedBgImage,
    }"
  >
    <!-- Content Container -->
    <div class="flex flex-col justify-between max-w-[322px] w-full h-full">
      <!-- Title -->
      <div class="flex flex-col gap-2.5">
        <h3
          class="text-base leading-5 font-semibold"
          :class="textWhite ? 'text-white' : 'text-text-primary'"
        >
          {{ title }}
        </h3>

        <!-- Description -->
        <p
          class="text-text-secondary text-[13px] font-medium"
          :class="textWhite ? 'text-white opacity-50' : 'text-text-secondary'"
        >
          {{ description }}
        </p>
      </div>

      <div class="flex flex-col gap-2.5">
        <!-- Price -->
        <div
          class="text-2xl font-semibold"
          :class="textWhite ? 'text-white' : 'text-text-primary'"
        >
          {{ priceText }}
        </div>

        <!-- Button -->
        <CButton type="primary" class="!bg-white" @click="$emit('learnMore')">
          {{ buttonText }}
        </CButton>
      </div>
    </div>
  </div>
</template>

<style>
.bg-image {
  background-position: right 16px top 16px;
  background-repeat: no-repeat;
}
</style>
